// removed by extract-text-webpack-plugin
module.exports = {"colorPrimaryOrange":"#e16e46","colorWhite":"#ffffff","colorBackground":"rgb(245, 244, 243)","oldColorViolet3":"#C6B1D7","repositoryList":"repository-file-picker__repositoryList____2HqsT","currentFile":"repository-file-picker__currentFile____CNtvd"};


//////////////////
// WEBPACK FOOTER
// ./src/admin/ui/components/repository-file-picker/repository-file-picker.css
// module id = 435
// module chunks = 0